<template>
  <div>
    <modal-import-teams
      ref="importTeams"
      @send-email="sendEmail"
      @send-sms="sendSMS"
    ></modal-import-teams>
    <modal-import-teams-v2
      ref="importTeamsV2"
      @send-email="sendEmail"
      @send-sms="sendSMS"
    ></modal-import-teams-v2>

    <div class="campaign-edit-title">
      <h2 class="h2-like">{{ $t("teams.teams_title", "Teams") }}</h2>

      <div class="btn-wrap d-flex flex-row justify-content-around">
        <div class="mx-1">
          <team-form
            ref="teamform"
            :currentpage="currentPage"
            :searchvalue="searchValue"
            :shortlink="campaignShortLink"
            :ccy="campaignCurrency"
            :default-team-avatar-src="teamDefaultAvatar ? teamDefaultAvatar.attributes.src : ''"
          />
        </div>
        <div class="mx-1">
          <email-message ref="emailMessage" />
        </div>
        <div class="mx-1">
          <sms-message ref="smsMessage" />
        </div>
        <div class="mx-1">
          <whatsapp-message ref="whatsappMessage" />
        </div>
        <div class="btn-group delete-all-teams mx-1">
          <b-dropdown
            :disabled="!hasAccessEdit"
            variant="-sm bttn--bordered-blue"
            right
            :text="$t('edit_campaign.teams_options', 'Options')"
          >
            <b-dropdown-item
              :class="this.teams.length === 0 || !hasAccessDeleteAllTeams ? 'disabled' : ''"
              v-on:click="deleteAllTeams"
            >
              {{ $t("edit_campaign.delete_all_teams", "Delete all teams") }}
            </b-dropdown-item>
            <b-dropdown-item @click="openModalImportTeams" v-if="hasAccessAdd">{{
              $t("edit_campaign.import_teams", "Import")
            }}</b-dropdown-item>
            <b-dropdown-item @click="openModalImportTeamsV2" v-if="hasAccessAdd">{{
              $t("edit_campaign.import_teams_mapped", "Import (mapped)")
            }}</b-dropdown-item>
            <b-dropdown-item @click="openModalExportTeams">{{
              $t("edit_campaign.export_button_teams_title", "Export")
            }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="team-default-avatar-block">
      <div class="team-default-avatar-block__preview">
        <img
          v-if="teamDefaultAvatar"
          :src="teamDefaultAvatar.attributes.src"
          :alt="$t('teams.team_default_avatar', 'Team default avatar')"
          class="team-default-avatar-block__image"
        />
        <div v-else class="team-default-avatar-block__placeholder">
          {{ $t("teams.team_default_avatar_empty", "No default team avatar") }}
        </div>
      </div>
      <div class="team-default-avatar-block__actions" v-if="hasAccessEdit">
        <button
          class="bttn bttn--sm bttn--bordered-blue"
          :disabled="teamAvatarLoading"
          @click="openTeamAvatarUpload"
        >
          <b-spinner v-if="teamAvatarLoading" small class="tw-mr-1" />
          {{
            $t(
              teamDefaultAvatar
                ? "teams.team_default_avatar_replace"
                : "teams.team_default_avatar_add",
              teamDefaultAvatar ? "Replace avatar" : "Add default avatar"
            )
          }}
        </button>
        <button
          v-if="teamDefaultAvatar"
          class="bttn bttn--sm bttn--bordered-blue"
          :disabled="teamAvatarLoading"
          @click="removeTeamAvatar"
        >
          <b-spinner v-if="teamAvatarLoading" small class="tw-mr-1" />
          {{ $t("teams.team_default_avatar_delete", "Delete avatar") }}
        </button>
      </div>
    </div>
    <export-teams ref="exportTeams"> </export-teams>
    <section class="teams-page" v-if="hasAccessSee">
      <div class="tw-flex tw-flex-wrap tw-flex-col md:tw-flex-row">
        <div
          class="tw-flex tw-flex-col tw-mb-[10px] tw-px-[10px] tw-w-full md:tw-w-1/2 lg:tw-w-1/3 tw-justify-end"
        >
          <label class="tw-pb-2 form-unit__label">{{
            $t("dashboard.filter_search", "Search")
          }}</label>
          <div class="search">
            <svg viewBox="0 0 17 17">
              <g fill="#107598" fill-rule="nonzero">
                <path
                  d="M11.22 3.29c.2.2.38.41.55.64l-.12-.16c.33.44.61.93.83 1.44l-.08-.19a6.76 6.76 0 0 1 .42 1.48 6.92 6.92 0 0 1 .03 1.52 6.76 6.76 0 0 1-.45 1.69l.08-.2c-.22.52-.5 1-.83 1.45l.12-.16c-.34.45-.74.85-1.18 1.2l.16-.12c-.43.34-.91.62-1.42.84l.2-.08a6.41 6.41 0 0 1-1.45.43 6.52 6.52 0 0 1-1.5.03 6.41 6.41 0 0 1-1.65-.46l.19.08c-.5-.22-.98-.5-1.42-.84l.16.12a6.67 6.67 0 0 1-1.18-1.2l.12.16a6.78 6.78 0 0 1-.83-1.45l.08.2a6.76 6.76 0 0 1-.42-1.48 6.92 6.92 0 0 1-.03-1.52c.08-.58.23-1.15.45-1.69l-.08.2c.22-.52.5-1 .83-1.45l-.12.16c.34-.45.74-.86 1.18-1.2l-.16.12c.44-.34.91-.62 1.42-.84l-.2.08a6.41 6.41 0 0 1 1.45-.43 6.52 6.52 0 0 1 1.5-.03c.57.08 1.12.23 1.65.46L9.33 2a6.43 6.43 0 0 1 1.89 1.28c.3.3.83.32 1.11 0a.83.83 0 0 0 0-1.14A7.13 7.13 0 0 0 .92 3.77a7.46 7.46 0 0 0 .85 8.43 7.16 7.16 0 0 0 9.02 1.58 7.53 7.53 0 0 0 2.48-2.38 7.46 7.46 0 0 0-.94-9.25c-.29-.3-.82-.32-1.11 0a.83.83 0 0 0 0 1.14z"
                />
                <path
                  d="M11.28 12.42l1.47 1.47 2.34 2.34.54.54c.3.3.85.32 1.14 0a.82.82 0 0 0 0-1.14l-1.47-1.47-2.34-2.34-.54-.54c-.3-.3-.85-.32-1.14 0a.82.82 0 0 0 0 1.14z"
                />
              </g>
            </svg>
            <input
              type="text"
              v-model="searchValue"
              :placeholder="$t('teams.search_placeholder', 'Type to search')"
              class="search__input"
            />
          </div>
        </div>

        <div
          class="tw-flex tw-flex-col tw-mb-[10px] tw-px-[10px] tw-w-full md:tw-w-1/2 lg:tw-w-1/3 tw-justify-end"
        >
          <label class="tw-pb-2 form-unit__label">{{
            $t("dashboard.filter_show_all", "Visibility")
          }}</label>
          <div class="select">
            <svg viewBox="0 0 12 6">
              <path
                fill="#A0A1AC"
                fill-rule="nonzero"
                d="M.28.28a.6.6 0 0 0 .02.86l5.25 4.6c.26.22.64.22.88 0l5.25-4.6c.26-.22.28-.6.02-.84a.65.65 0 0 0-.9-.02L6 4.48 1.18.26a.67.67 0 0 0-.9.02z"
              />
            </svg>
            <select class="select__select" v-model="sortByShown">
              <option value>{{ $t("dashboard.teams_filter_all", "Any") }}</option>
              <option value="true">{{ $t("dashboard.teams_filter_hidden", "Hidden") }}</option>
              <option value="false">{{ $t("dashboard.teams_filter_shown", "Shown") }}</option>
            </select>
          </div>
        </div>

        <div
          class="tw-flex tw-flex-col tw-mb-[10px] tw-px-[10px] tw-w-full md:tw-w-1/2 lg:tw-w-1/3 tw-justify-end"
        >
          <label class="tw-pb-2 form-unit__label">{{
            $t("dashboard.parent_team", "Parent team")
          }}</label>
          <multiselect-search
            v-model="parentTeamId"
            :open-prefetch="true"
            :search-url="getTeamSearchUrl"
            :search-options="teamSearchOptions"
            aria-describedby="parent-team-help"
          >
            <template #no-options>
              {{ $t("dashboard.team_search_no_options", "Please enter 1 or more characters") }}
            </template>
            <template #no-more-infinite>
              {{ $t("dashboard.team_search_no_more", "No more teams") }}
            </template>
          </multiselect-search>
        </div>
      </div>
      <error v-if="errors" :errors="errors"></error>
      <div class="row" v-if="teams.length > 0">
        <div class="col-12 col-md-6" v-for="team in teams" :key="team.id">
          <team-plate
            :team="team"
            @copy-link="linkCopyAlert"
            @edit-team="editTeam"
            @delete-team="deleteTeam"
            @send-email="sendEmail"
            @send-sms="sendSMS"
            @send-whatsapp="sendWhatsapp"
            @team-updated="loadNewPageTeams"
          />
        </div>
      </div>

      <div v-else class="empty-result-message">
        {{ $t("teams.teams_empty") }}
      </div>

      <b-pagination
        v-if="teamsCount > 50"
        size="md"
        :total-rows="teamsCount"
        v-model="currentPage"
        :per-page="50"
      >
      </b-pagination>
    </section>
    <section class="teams-page" v-else>
      <div class="empty-result-message">
        {{ $t("teams.teams_access_error") }}
      </div>
    </section>

    <infoModal :message="$t('teams.link_copied_to_clipboard')" ref="copyAlert" />
    <MediaStorageCropperModal ref="MediaStorageCropperModal" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";

import teamForm from "./team-form.vue";
import campaignTeamPlate from "./campaignTeamPlate.vue";
import campaignImportTeams from "./campaign-import-teams.vue";
import campaignImportTeamsV2 from "./campaign-import-teams-v2.vue";
import error from "@/components/errors";

import { notificationsMixin } from "@/mixins";
import urls from "@/constants/urls.js";

import exportTeams from "@/views/dashboard/subcomponents/export-teams-modal.vue";
import infoModal from "@/components/info-modal.vue";
import SmsMessage from "@/views/dashboard/subcomponents/messaging/smsMessage.vue";
import EmailMessage from "@/views/dashboard/subcomponents/messaging/emailMessage.vue";
import WhatsappMessage from "@/views/dashboard/subcomponents/messaging/whatsappMessage.vue";
import MultiselectSearch from "@/components/multiselect-search.vue";
import MediaStorageCropperModal from "@/views/media-storage/MediaStorageCropperModal.vue";
import debounce from "lodash/debounce";

export default {
  mixins: [notificationsMixin],

  data: function () {
    return {
      currentPage: 1,
      searchValue: "",
      errors: [],
      sortByShown: "",
      parentTeamId: null,
      parent_team_id: null,
      teamAvatarLoading: false,
    };
  },

  components: {
    "team-form": teamForm,
    "team-plate": campaignTeamPlate,
    "modal-import-teams": campaignImportTeams,
    "modal-import-teams-v2": campaignImportTeamsV2,
    exportTeams,
    infoModal,
    error,
    SmsMessage,
    EmailMessage,
    WhatsappMessage,
    MultiselectSearch,
    MediaStorageCropperModal,
  },

  computed: {
    ...mapState({
      campaignId: (state) => {
        return state.campaign.campaign.data.id;
      },

      teams: (state) => {
        if (state.teams.teams) {
          return state.teams.teams.sort(function (a, b) {
            if (a.attributes.sort === b.attributes.sort) {
              return a.id - b.id;
            }
            return a.attributes.sort - b.attributes.sort;
          });
        }
        return [];
      },

      teamsCount: (state) => {
        return state.teams.teamsCount;
      },

      orgId: function () {
        return localStorage.getItem("orgId");
      },

      campaignShortLink: (state) => {
        return state.campaign.campaign.data.attributes.short_link;
      },

      campaignCurrency: (state) => {
        return state.campaign.campaign.data.attributes.currency;
      },

      allMediaArr: (state) => {
        const relationships = state.campaign.campaign.data.relationships.campaign_media.data || [];
        const included = state.campaign.campaign.included || [];

        return relationships
          .map((relation) =>
            included.find((el) => el.id == relation.id && el.type == relation.type)
          )
          .filter(Boolean);
      },

      hasAccessSee: (state) => {
        return state.account.access.CanSeeCampaignTeams;
      },
      hasAccessEdit: (state) => {
        return state.account.access.CanEditCampaignTeams;
      },
      hasAccessAdd: (state) => {
        return state.account.access.CanAddCampaignTeams;
      },
      hasAccessDeleteAllTeams: (state) => {
        return state.account.access.CanDeleteAllCampaignTeams;
      },
    }),

    teamDefaultAvatar() {
      return (
        this.allMediaArr
          .filter(
            (el) =>
              el?.attributes?.tag === "team_default_avatar" && Number(el.attributes.team_id) === 0
          )
          .sort((a, b) => Number(a.attributes.order || 0) - Number(b.attributes.order || 0))[0] ||
        null
      );
    },

    getTeamSearchUrl() {
      const cID = this.campaignId;
      const orgID = this.orgId;

      if (Number(cID) === 0) {
        throw new Error("getTeamSearchUrl campaign teams parent picker campaign id is 0");
      }

      return urls.apiTeams.replace(":orgId", orgID).replace(":campaignId", cID);
    },

    teamSearchOptions() {
      return {
        placeholder: this.$t("dashboard.select_parent_team", "Select parent team"),
        changeParams: ({ query, page, per_page: pp }) => ({
          q: query,
          page: page,
          limit: pp,
        }),
        customLabel: (e) => `[${e.id}] ${e.name}`,
        processResults: (data) =>
          data.map((el) => ({
            id: el.id,
            ...el.attributes,
          })),
      };
    },
  },

  directives: {
    debounce,
  },

  watch: {
    currentPage: function () {
      this.loadNewPageTeams();
    },

    sortByShown() {
      this.currentPage = 1;
      this.loadNewPageTeams();
    },

    parentTeamId: debounce(function () {
      if (this.parentTeamId) {
        this.parent_team_id = Number(this.parentTeamId.id);
      } else {
        this.parent_team_id = 0;
      }
      this.currentPage = 1;
      this.loadNewPageTeams();
    }, 500),

    searchValue: debounce(function () {
      this.loadNewPageTeams();

      this.currentPage = 1;
    }, 500),
  },

  methods: {
    ...mapActions({
      seferTorahFetchIsActive: "seferTorahPages/fetchIsActive",
    }),

    openModalImportTeams: function () {
      this.$refs.importTeams.openModal();
    },

    openModalImportTeamsV2: function () {
      this.$refs.importTeamsV2.openModal();
    },

    openModalExportTeams() {
      this.$refs.exportTeams.openModal(this.campaignId);
    },

    sendEmail({ team, importGroup } = {}) {
      this.$refs.emailMessage.open({ team, importGroup });
    },

    sendSMS({ team, importGroup } = {}) {
      this.$refs.smsMessage.open({ team, importGroup });
    },

    sendWhatsapp({ team, importGroup } = {}) {
      this.$refs.whatsappMessage.open({ team, importGroup });
    },

    editTeam: function (team) {
      this.$refs.teamform.openEditModal(team);
    },

    loadNewPageTeams() {
      const params = [
        "extend=stats",
        "limit=50",
        `page=${this.currentPage}`,
        `hidden=${this.sortByShown}`,
      ];

      if (this.searchValue) {
        params.push(`q=${this.searchValue}`);
      }

      if (this.parent_team_id) {
        params.push(`parent_team_id=${this.parent_team_id}`);
      }

      let teamsParams = `?${params.join("&")}`;

      this.$store.dispatch("getTeams", teamsParams);
    },

    deleteAllTeams: function () {
      if (!this.hasAccessDeleteAllTeams) {
        return false;
      }

      if (this.teamsCount === 0) {
        return 0;
      }

      axios
        .get(urls.teamManagementSums.replace(":oid", this.orgId), {
          params: { campaign_id: this.campaignId },
        })
        .then(({ data }) => {
          const count = Number(data.data.attributes.teams_count) || 0;

          let message = this.$t("teams.confirm_delete_all_teams", {
            count,
          });

          let options = {
            view: "delete-width-checkbox-confirm",
            okText: this.$t("teams.confirm_delete"),
            cancelText: this.$t("teams.confirm_cancel"),
            confirmDeleteText: this.$t("teams.confirm_delete_team_text", {
              count,
            }),
            count,
          };

          this.$dialog.alert(message, options).then(() => {
            axios
              .delete(
                urls.deleteAllTeams
                  .replace(":orgId", this.orgId)
                  .replace(":campaignId", this.campaignId)
              )
              .then(() => {
                let teamsParams = `?limit=50&page=1&q=${this.searchValue}`;

                this.$store.dispatch("getTeams", teamsParams);

                this.$_notificationsMixin_makeToastCompat({
                  group: "Notification",
                  title: this.$t("teams.success_delete_all_teams"),
                });
              })
              .catch((e) => {
                this.$_notificationsMixin_makeToastCompat({
                  group: "Notification",
                  type: "danger",
                  title: e.response.data.error,
                });
              });
          });
        })
        .catch((e) => {
          this.$_notificationsMixin_makeToastCompat({
            group: "Notification",
            type: "danger",
            title: this.$_notificationsMixin_string(e),
          });
        });
    },

    deleteTeam: function (team) {
      let message = this.$t("teams.confirm_delete_team");

      let options = {
        okText: this.$t("teams.confirm_delete"),
        cancelText: this.$t("teams.confirm_cancel"),
      };

      this.$dialog.confirm(message, options).then(() => {
        axios
          .delete(
            urls.editTeams.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId) +
              "/" +
              team.id
          )
          .then(() => {
            let teamsParams = `?limit=50&page=${this.currentPage}&q=${this.searchValue}`;

            this.$store.dispatch("getTeams", teamsParams);

            this.$_notificationsMixin_makeToast(
              "Success!",
              this.$t("teams.success_delete"),
              "success"
            );
          })
          .catch((e) => {
            if (e.response.data) {
              if (e.response.data.error) {
                this.errors.push(e.response.data.error);
              } else {
                this.errors.push(this.$t("template.error_default"));
              }
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          });
      });
    },

    linkCopyAlert() {
      this.$refs.copyAlert.openModal();
    },

    openTeamAvatarUpload() {
      if (!this.hasAccessEdit || this.teamAvatarLoading) {
        return;
      }

      const fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/webp");
      fileInput.classList.add("load-image-input");

      fileInput.addEventListener("change", () => {
        if (fileInput.files != null && fileInput.files[0] != null) {
          this.$refs.MediaStorageCropperModal.open({
            file: fileInput.files[0],
            tag: "team_default_avatar",
          });
          this.$refs.MediaStorageCropperModal.onOK((blob) => {
            this.uploadTeamAvatar(blob).finally(() => {
              fileInput.remove();
            });
          });
          this.$refs.MediaStorageCropperModal.onClose(() => {
            fileInput.remove();
          });
        }
      });

      document.querySelector("body").appendChild(fileInput);
      fileInput.click();
    },

    async uploadTeamAvatar(file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        this.teamAvatarLoading = true;
        const uploadResponse = await axios.post(urls.loadImageQuill, formData);
        const src = uploadResponse?.data?.src;

        if (!src) {
          throw new Error("Failed to upload team default avatar");
        }

        if (this.teamDefaultAvatar) {
          const mediaUpdatePayload = {
            data: {
              attributes: {
                ...this.teamDefaultAvatar.attributes,
                src,
              },
            },
          };

          await axios.put(
            `${urls.loadImage
              .replace(":orgId", this.orgId)
              .replace(":campaignId", this.campaignId)}/${this.teamDefaultAvatar.id}`,
            mediaUpdatePayload
          );
        } else {
          const mediaCreatePayload = {
            data: {
              attributes: {
                campaign_id: Number(this.campaignId),
                src,
                tag: "team_default_avatar",
                order: 1,
                lang: "",
                team_id: 0,
              },
            },
          };

          await axios.post(
            urls.loadImage.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId),
            mediaCreatePayload
          );
        }

        await this.$store.dispatch(
          "updateCampaign",
          "?extend=campaign_stats&extend=content&extend=media&extend=matchers"
        );
        this.$_notificationsMixin_makeToast(
          "Success!",
          this.$t("teams.team_default_avatar_saved", "Team default avatar saved"),
          "success"
        );
      } catch (e) {
        this.$_notificationsMixin_handleCatch(e);
      } finally {
        this.teamAvatarLoading = false;
      }
    },

    async removeTeamAvatar() {
      if (!this.teamDefaultAvatar || this.teamAvatarLoading) {
        return;
      }

      const message = this.$t(
        "teams.team_default_avatar_delete_confirm",
        "Are you sure you want to delete the default team avatar?"
      );
      const options = {
        okText: this.$t("teams.confirm_delete"),
        cancelText: this.$t("teams.confirm_cancel"),
      };

      this.$dialog.confirm(message, options).then(async () => {
        try {
          this.teamAvatarLoading = true;
          await axios.delete(
            `${urls.loadImage
              .replace(":orgId", this.orgId)
              .replace(":campaignId", this.campaignId)}/${this.teamDefaultAvatar.id}`
          );
          await this.$store.dispatch(
            "updateCampaign",
            "?extend=campaign_stats&extend=content&extend=media&extend=matchers"
          );
          this.$_notificationsMixin_makeToast(
            "Success!",
            this.$t("teams.team_default_avatar_deleted", "Team default avatar deleted"),
            "success"
          );
        } catch (e) {
          this.$_notificationsMixin_handleCatch(e);
        } finally {
          this.teamAvatarLoading = false;
        }
      });
    },
  },

  created() {
    this.$store.dispatch("getContacts");
    const p = {
      cId: this.$route.params.id,
    };
    this.seferTorahFetchIsActive(p);
  },
};
</script>

<style lang="scss" scoped>
// .delete-all-teams {
//   margin-left: 20px;
// }

.disabled {
  ::v-deep a {
    cursor: not-allowed;
  }
}

.team-default-avatar-block {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.team-default-avatar-block__preview {
  width: 80px;
  height: 80px;
}

.team-default-avatar-block__image,
.team-default-avatar-block__placeholder {
  width: 100%;
  height: 100%;
  border-radius: 9999px;
}

.team-default-avatar-block__image {
  object-fit: cover;
  border: 2px solid #88bacc;
}

.team-default-avatar-block__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  color: #7f8b98;
  border: 1px dashed #b8c2cc;
  padding: 6px;
}

.team-default-avatar-block__actions {
  display: flex;
  gap: 8px;

  & button:disabled {
    background-color: transparent;
  }
}

::v-deep .multiselect__tags {
  height: 48px;
  width: 100%;
  padding-left: 45px;
  border: 1px solid #88bacc;
  border-radius: 24px;
  padding: 0;
  padding-left: 30px;
}
::v-deep .multiselect__single,
::v-deep .multiselect__placeholder {
  margin: 0;
  line-height: 48px;
  background: #0000;
}
::v-deep .multiselect__select {
  height: 48px;
}
::v-deep .multiselect__input,
::v-deep .multiselect__single,
::v-deep .multiselect__placeholder {
  height: 48px;
  margin: 0;
  line-height: 48px;
  background: transparent;
  color: initial;
  padding: 0;
  font-family: inherit;
  font-size: 16px;
}
</style>
